export default __webpack_public_path__ + "static/media/blueTheme-boy.766e140d.svg";